import axios from 'axios';

axios.defaults.headers.authorization = 'bearer ' + localStorage.getItem('token');
axios.defaults.headers.get['Pragma'] = 'no-cache';
axios.defaults.headers.get['Cache-control'] = 'no-cache, no-store';

export default axios;